import { dispatchStopReadAloudEvent, ReadAloudController, useReadAloud } from '@3plearning/question-components-library';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const TtsController = ({ readAloudConfig }) => {
  const { conquestQuestionId } = useSelector(state => state.conquestReducer);
  const { setIsTranscriptModalOpen } = useReadAloud();

  useEffect(() => {
    dispatchStopReadAloudEvent();
    setIsTranscriptModalOpen(false);
  }, [conquestQuestionId]);

  return (
    <Box
      position="absolute"
      zIndex={1}
      left="-20px"
      top="20px"
      __css={{
        button: {
          borderRadius: '50%'
        }
      }}
    >
      <ReadAloudController
        readAloudConfig={readAloudConfig}
        containerId="new-content-container"
        key={conquestQuestionId}
      />
    </Box>
  );
};

TtsController.propTypes = {
  readAloudConfig: PropTypes.shape({
    enabled: PropTypes.bool,
    gatewayUrl: PropTypes.string,
    token: PropTypes.string,
    locale: PropTypes.string
  }).isRequired
};

export default TtsController;
